import Vue from "vue";

Vue.filter("truncate", (text = "", length = 30) => {
  if (text.length <= length) return text;
  let clamp = "…";
  let truncated = text.slice(0, length - clamp.length);
  let last = truncated.length - clamp.length;

  truncated = truncated.slice(0, last);

  return truncated + clamp;
});
